import React from 'react';
import Carousel from '@comp/Carousel/Carousel';
import styled from '@emotion/styled';
import useWindowSize from '@hooks/useWindowSize';
import { mediaQuery, Spacings } from '@styles/index';
import CarouselCourseCard from './CarouselCourseCard';

type CourseCarouselType = {
  uuid: string;
  title: string;
  tagline: string;
  coverRectangle: string;
};

interface CourseCarouselProps {
  courseList: CourseCarouselType[];
}

const CarouselComp = Carousel as any;

const Wrapper = styled.div`
  ${mediaQuery.uptoTablet} {
    overflow: hidden;
    padding: 0 ${Spacings.SPACING_4B};
  }
`;

const CourseCarousel: React.FC<CourseCarouselProps> = ({ courseList }) => {
  const { isMobile } = useWindowSize();

  return (
    <Wrapper>
      <CarouselComp
        numberOfItems={4}
        minItems={1}
        showControls
        showInfo={false}
        gridColumnGap={isMobile ? Spacings.SPACING_22 : Spacings.SPACING_6B}
        gridColumn={isMobile ? 'span 4' : 'span 7'}
        itemGridColumn={isMobile ? 'span 4' : 'span 7'}
        isUnIconArrow
        showBottomGap={false}
        paddingBottom="0"
        key="continue-watching"
      >
        {courseList.map((card) => (
          <React.Fragment key={card.uuid}>
            <CarouselCourseCard
              title={card.title}
              cover={card.coverRectangle}
              tagline={card.tagline}
            />
          </React.Fragment>
        ))}
      </CarouselComp>
    </Wrapper>
  );
};

CourseCarousel.displayName = 'CourseCarousel';

export default CourseCarousel;
